module.exports = __webpack_public_path__ + "static/media/wuerchahushan_web.9a2446e7.webp";